module.exports = __webpack_public_path__ + "static/media/ic-cal-white.a0be611c.svg";